import React from 'react';
import { BookingCalendar } from '../components/BookingCalendar';
export function BookingPage() {
  return <>
      {/* Hero */}
      <section className="bg-olive py-12 md:py-16" data-id="element-753">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-754">
          <div className="text-center max-w-3xl mx-auto" data-id="element-755">
            <span className="text-gold font-bold uppercase tracking-widest text-xs mb-4 block" data-id="element-756">
              BOOK ONLINE
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-757">
              Schedule Your{' '}
              <span className="italic text-cream" data-id="element-758">Appointment</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg font-medium" data-id="element-759">
              No waitlist — immediate availability. No referral required.
            </p>
          </div>
        </div>
      </section>

      {/* Booking Calendar — reuse existing component but with cream bg */}
      <section className="py-12 lg:py-16 bg-cream" data-id="element-760">
        <BookingCalendar data-id="element-761" />
      </section>
    </>;
}